import React from 'react';
import styled from 'styled-components';

import type { IPanelLabel } from './types';

import { otherColors } from '@/styles/colors';
import { flex, sizing } from '@/styles/theme';
import { classList } from '@/helpers';

const PanelLabel = (props: IPanelLabel): React.ReactElement => {
  const isLineTop = props.linesPosition === 'top';
  const width = props.width ?? 'auto';

  return (
    <div className={`panel-label mb-3 ${isLineTop ? flex.columnReverse : flex.column}`} style={{ width: width }}>
      <Header className={props.className}>{props.children}</Header>
      <LinesContainer className={classList('color-accent', `${isLineTop ? 'mb-2' : ''}`)}>
        <Line width={props?.lineWidth} height={props?.lineHeight} color={otherColors.lxc.navyBlue} />
        <Line width={props?.lineWidth} height={props?.lineHeight} color={otherColors.lxc.blue} />
        <Line width={props?.lineWidth} height={props?.lineHeight} color={otherColors.lxc.purple} />
        <Line width={props?.lineWidth} height={props?.lineHeight} color={otherColors.lxc.orange} />
      </LinesContainer>
    </div>
  );
};

export { PanelLabel };

const Header = styled.h1`
  color: ${otherColors.lxc.dark};
  font-size: ${sizing.fontSize.xxl};
  font-weight: 300;
`;

const LinesContainer = styled.div`
  display: flex;
`;

const Line = styled.div<{ width?: string; height?: string }>`
  height: ${props => props.height ?? '5px'};
  width: ${props => props.width ?? '43px'};
  margin-left: 5px;
  background-color: ${props => props.color};
  border-radius: 6px;

  &:first-child {
    margin-left: 0;
  }
`;
